import catalogModule from '../../catalog/catalogModule';

function breadcrumbsController($log, $scope, catalogConstants, constantsService) {
    "ngInject";

    $scope.showGenreBreadcrumb = function () {
        var genreBreadcrumb = $scope.getGenreBreadcrumb();
        return genreBreadcrumb && genreBreadcrumb.length > 0;
    }

    $scope.getGenreBreadcrumb = function () {
        const { genres } = $scope.navigationMenu;

        if (!genres) {
            return null;
        }

        var selectedGenres = genres.filter(function (genre) {
            return genre.isSelected;
        });

        var numOfGenresSelected = selectedGenres.length;

        if (numOfGenresSelected === 1) {
            return selectedGenres[0].name;
        }
        else if (numOfGenresSelected === 2) {
            return constantsService.genreOrText(selectedGenres[0].name, selectedGenres[1].name);
        }
        else if (numOfGenresSelected > 2) {
            return constantsService.genreTextSelected(numOfGenresSelected);
        }

        return null;
    }

    $scope.showCreatorBreadcrumb = function () {
        return $scope.data.creatorBreadcrumb && $scope.data.creatorBreadcrumb.length > 0;
    }

    $scope.showPriceBreadcrumb = function () {
        return $scope.showFreeBreadcrumb() || $scope.showCustomPriceBreadcrumb();
    }

    $scope.showFreeBreadcrumb = function () {
        return $scope.data.showFreeBreadcrumb;
    }

    $scope.showCustomPriceBreadcrumb = function () {
        if (!$scope.data.currencyType || $scope.data.currencyType.currencyType !== $scope.library.customRobuxFilterId) {
            return false;
        }

        if (!$scope.data.minPriceBreadcrumb && !$scope.data.maxPriceBreadcrumb) {
            $scope.data.showFreeBreadcrumb = true;
            return false;
        }

        var minPriceBreadcrumb = $scope.data.minPriceBreadcrumb;
        return (typeof minPriceBreadcrumb === 'number') && (minPriceBreadcrumb % 1 === 0);
    }

    $scope.isNonDefaultSubcategorySelected = function () {
        var cat = $scope.getCategoryOption($scope.currentQuery.category);

        if (!cat || !cat.subcategories || !$scope.currentQuery.subcategory) {
            return false;
        }

        var defaultSubcategory = cat.subcategories[0];
        return defaultSubcategory.subcategoryId !== $scope.currentQuery.subcategory.subcategoryId;
    }

    $scope.clearSubcategory = function () {
        var cat = $scope.getCategoryOption($scope.currentQuery.category);
        // Set subcategory to the default for the category if the category has a subcategory menu
        if (!cat || !cat.subcategories) {
            $scope.currentQuery.subcategory = null;
        }
        else {
            var defaultSubcategory = cat.subcategories[0];
            $scope.currentQuery.subcategory = defaultSubcategory;
        }

        $scope.clearGenres();
    }

    $scope.clearGenres = function (stopChaining, keepKeyword) {
        const { genres } = $scope.navigationMenu;

        if (genres) {
            for (let i = 0; i < genres.length; i++) {
                genres[i].isSelected = false;
            }
        }

        if (stopChaining) {
            $scope.clearKeyword();
            return;
        }

        $scope.clearCreator(false, keepKeyword);
    }

    $scope.clearCreator = function (stopChaining, keepKeyword) {
        $scope.data.creator = $scope.data.creators.find(function (creator) {
            return creator.userId === $scope.library.defaultCreatorId;
        });

        if (stopChaining) {
            $scope.clearKeyword();
            return;
        }

        $scope.clearPrice(keepKeyword);
    }

    $scope.clearPrice = function (keepKeyword) {
        $scope.data.currencyType = $scope.data.currencyTypes ? $scope.data.currencyTypes[0] : null;

        if (keepKeyword) {
            $scope.applySearch(true);
        }
        else {
            $scope.clearKeyword();
        }
    }

    $scope.clearKeyword = function () {
        $scope.searchLayout.keyword = null;
        $scope.applySearch(true);
    }

    var clearFilters = $scope.$on(catalogConstants.clearFiltersEvent, function (event, args) {
        var keepKeyword = false;

        if (args && args.keepKeyword) {
            keepKeyword = true;
        }

        $scope.clearGenres(false, keepKeyword);
    });

    $scope.$on("$destroy", function () {
        if (clearFilters) {
            clearFilters();
        }
    });
}

catalogModule.controller("breadcrumbsController", breadcrumbsController);

export default breadcrumbsController;